const InformationTitle = (title) => (
    <h2 className="text-2xl font-bold text-center w-full mb-4">{title}</h2>
);

export default InformationTitle;